import { render, staticRenderFns } from "./detailComplaintCorporate.vue?vue&type=template&id=5a7035d2&"
import script from "./detailComplaintCorporate.vue?vue&type=script&lang=js&"
export * from "./detailComplaintCorporate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports